"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcProductPrices = exports.UcProductGeneral = exports.FieldsetProductGeneral = void 0;
const FieldsetProductGeneral_yaml_component_1 = __importDefault(require("./FieldsetProductGeneral.yaml?component"));
exports.FieldsetProductGeneral = FieldsetProductGeneral_yaml_component_1.default;
const UcProductGeneral_yaml_component_1 = __importDefault(require("./UcProductGeneral.yaml?component"));
exports.UcProductGeneral = UcProductGeneral_yaml_component_1.default;
const UcProductPrices_yaml_component_1 = __importDefault(require("./UcProductPrices.yaml?component"));
exports.UcProductPrices = UcProductPrices_yaml_component_1.default;
